// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__a4lR8","LogoImg":"Logo_LogoImg__SNbRi"};